import React from "react";

import { Plus } from "shared/assets/icons";
import { space, VisuallyHiddenElement } from "shared/styles/constants";
import { ITheme } from "shared/types";
import { CSSProperties } from "styled-components";

import {
  StyledIconButton,
  StyledIconButtonProps,
  StyledIcon,
  StyledIconButtonLink,
} from "./styles";

interface IconButtonProps extends StyledIconButtonProps {
  label?: string; // required for a11y
  icon?: React.ComponentType<any>;
  iconTransform?: string;
  onClick?: () => void;
  style?: CSSProperties;
  iconStyle?: CSSProperties;
  iconSize?: keyof typeof space;
  disabled?: boolean;
  to?: string;
}

export const IconButton: React.FC<IconButtonProps> = ({
  icon = Plus,
  iconTransform,
  label,
  to,
  onClick,
  style,
  iconStyle,
  theme = ITheme.primary,
  size = "s",
  disabled,
  iconSize,
  ...rest
}) => {
  const renderInner = () => (
    <React.Fragment>
      <StyledIcon
        as={icon}
        style={{ transform: iconTransform, ...iconStyle }}
        theme={theme}
        size={iconSize}
      />
      <VisuallyHiddenElement>{label}</VisuallyHiddenElement>
    </React.Fragment>
  );

  if (onClick) {
    return (
      <StyledIconButton
        type="button"
        onClick={onClick}
        style={style}
        theme={theme}
        size={size}
        disabled={disabled}
        {...rest}
      >
        {renderInner()}
      </StyledIconButton>
    );
  }

  if (to) {
    return (
      <StyledIconButtonLink to={to} style={style} theme={theme} size={size} {...rest}>
        {renderInner()}
      </StyledIconButtonLink>
    );
  }

  return (
    <StyledIconButton as="span" style={style} theme={theme} size={size} {...rest}>
      {renderInner()}
    </StyledIconButton>
  );
};
